var _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVerticalLine = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 3,
  height: 31,
  viewBox: "0 0 3 31",
  fill: "none",
  ref: svgRef
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 0.666748,
  width: 3,
  height: 30,
  rx: 1.5,
  fill: "#11B048"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVerticalLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vertical-line.a8dfd163.svg";
export { ForwardRef as ReactComponent };